import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Themes by Copilot is being retired. When this returns true, the Copilot theme section is hidden
 * from Settings, no Copilot theme can be selected and dynamic themes stop refreshing. Users who
 * already have a Copilot theme applied keep it until they switch to a non-Copilot theme.
 */
export default function isCopilotThemeRetired(): boolean {
    return isGlobalFeatureEnabled('settings-copilot-themes-retire');
}
